
const getEnv = (key: string, fallback: string = ""): string => {
  const runtimeConfig: RuntimeConfig | undefined =
    typeof window !== "undefined" ? window.__RUNTIME_CONFIG__ : undefined;
  const runtimeValue: string | undefined = runtimeConfig?.[key];

  const viteKey: string = `VITE_${key}`;
  const raw: unknown = import.meta.env[viteKey];
  const buildTimeRaw: string | boolean | undefined =
    raw === undefined ||
    typeof raw === "string" ||
    typeof raw === "boolean"
      ? raw
      : undefined;
  const buildTime: string | undefined =
    typeof buildTimeRaw === "string" ? buildTimeRaw : undefined;

  const result: string = runtimeValue ?? buildTime ?? fallback;

  return result;
};

export const appConfig = {
  baseUrl: getEnv("BASE_URL"),
  apiTimeout: Number(getEnv("API_TIMEOUT", "30000")),
  defaultTenantId: getEnv("DEFAULT_TENANT_ID"),
  serviceName: getEnv("SERVICE_NAME", "back-office-front"),
  supportAgencyClientId: getEnv("SUPPORT_AGENCY_CLIENT_ID"),
  oauth: {
    enabled: getEnv("OAUTH_ENABLED") === "true",
    authorizationUrl: getEnv("OAUTH_AUTHORIZATION_URL"),
    logoutUrl: getEnv("OAUTH_LOGOUT_URL"),
    tokenUrl: getEnv("OAUTH_TOKEN_URL"),
    clientId: getEnv("OAUTH_CLIENT_ID"),
    redirectUri: getEnv("OAUTH_REDIRECT_URI"),
    scope: getEnv("OAUTH_SCOPE", "openid profile email"),
    userInfoUrl: getEnv("OAUTH_USERINFO_URL"),
  },
  sentry: {
    enabled: getEnv("SENTRY_ENABLED") === "true",
    dsn: getEnv("SENTRY_DSN"),
    environment: getEnv("SENTRY_ENVIRONMENT") || import.meta.env.MODE,
    tracesSampleRate: Number(getEnv("SENTRY_TRACES_SAMPLE_RATE", "0.1")),
    release: getEnv("SENTRY_RELEASE"),
    devSend: getEnv("SENTRY_DEV_SEND") === "true",
  },
} as const;
